import Sortable from 'sortablejs';

require('leaflet');

import proj4 from 'proj4';

const {parse} = require('wkt');

/**
 * sortFlaechenVerwalten
 */
window.sortFlaechenVerwalten = function() {
  const tableFlaechenVerwalten = document.getElementById('list-flaechenVerwalten');

  Array.prototype.forEach.call(tableFlaechenVerwalten.querySelectorAll('.section-list'), function(element) {
    Sortable.create(element, {
      draggable: '.section-item',
      animation: 150,
      easing: '',
      group: {
        name: 'section-group',
      },
      onEnd: function(evt) {
        var selectedElement = evt.item.getAttribute('data-section-id');  // dragged HTMLElement

        const elementIDs = [];
        Array.prototype.forEach.call(tableFlaechenVerwalten.querySelectorAll('.section-item'), function(element) {
          const sectionID = element.getAttribute('data-section-id');
          const plantID = element.closest('div.section-list').getAttribute('data-plant-id');
          elementIDs.push(plantID + '-' + sectionID);
        });

        fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveSorting', {
          method: 'POST',
          body: JSON.stringify({
            area: 'flaechenVerwalten',
            elements: elementIDs,
          }),
        }).then(function(response) {
          if (typeof ListFlaechenVerwalten !== 'undefined') {
            ListFlaechenVerwalten.updater({
              selectedSectionID: selectedElement,
            });
          }

          return response.text();
        });
      },
    });
  });
};

/**
 * initMap
 * @param mapSelector
 * @param shapes
 * @param selectedSectionID
 */
window.initMap = function(mapSelector, shapes, selectedSectionID = 0) {
  if (!shapes) {
    return;
  }

  if (!mapSelector) {
    return;
  }

  // parse shape with wkt-package
  const parsedShapes = [];
  for (let key in shapes) {
    const parsedShape = parse(shapes[key]);

    parsedShape.sectionID = parseInt(key);
    parsedShapes.push(parsedShape);
  }

  // convert coordinates
  for (let key in parsedShapes) {
    convertArray(parsedShapes[key].coordinates);
  }

  // map init
  const map = L.map(document.querySelector(mapSelector), {
    maxBounds: L.latLngBounds(L.latLng(46, 10), L.latLng(47.2, 12.5)),
    minZoom: 10,
    maxZoom: 18,
    zoomControl: true,
  });

  if (selectedSectionID === 0) {
    map.setView([46.66, 11.4], 9);
  }

  // copyright
  const copy = '&copy; ' + (new Date()).getFullYear() + ' Autonome Provinz Bozen - Südtiroler Informatik AG • Steuernummer: 00390090215';

  // layers
  const mapLayers = [];
  mapLayers.push(L.tileLayer.wms('https://geoservices1.civis.bz.it/geoserver/p_bz-TransportNetwork/ows?language=de', {
    attribution: copy,
    srs: 'EPSG:3857',
    width: 256,
    zoomOffset: 0,
    maxZoom: 22,
    height: 256,
    layers: 'Links,Links-Sequences',
    format: 'image/png',
    transparent: true,
    opacity: .3,
    uppercase: true,
    zIndex: 3,
  }));

  mapLayers.push(L.tileLayer.wms('https://geoservices.buergernetz.bz.it/mapproxy/p_bz-Orthoimagery/wms', {
    attribution: copy,
    srs: 'EPSG:3857',
    width: 256,
    zoomOffset: 0,
    maxZoom: 22,
    height: 256,
    layers: 'Aerial-2020-RGB',
    format: 'image/png',
    transparent: true,
    uppercase: true,
    zIndex: 2,
  }));

  mapLayers.push(L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    opacity: .2,
    zIndex: 1,
  }));

  for (let key in mapLayers) {
    mapLayers[key].addTo(map);
  }

  L.control.scale().addTo(map);

  // Shapes
  const shapesLayer = L.geoJSON(parsedShapes);
  map.addLayer(shapesLayer);

  const bounds = shapesLayer.getBounds();
  if (bounds.isValid() && selectedSectionID === 0) {
    map.fitBounds(bounds);
  }

  // click section-item
  for (let key in shapesLayer._layers) {
    const currentLayer = shapesLayer._layers[key];
    const sectionID = currentLayer.feature.geometry.sectionID;
    const sectionSelector = document.querySelector('div.section-item[data-section-id="' + sectionID + '"]');
    const sectionColor = sectionSelector.getAttribute('data-color');
    if (sectionColor) {
      currentLayer.setStyle({
        color: '#FFFFFF',
        weight: 1,
        opacity: .5,
        fillColor: sectionColor,
        fillOpacity: .6,
      });

      if (sectionSelector) {
        sectionSelector.addEventListener('click', function() {
          resetHighlight(shapesLayer, currentLayer, sectionID);
          map.fitBounds(currentLayer.getBounds());
        });
      }

      // auf die verschobene flaeche zoomen
      if (selectedSectionID > 0) {
        if (selectedSectionID === sectionID) {
          map.fitBounds(currentLayer.getBounds());
        }
      }
    }
  }

  // click polygon
  shapesLayer.on('click', function(e) {
    const currentLayer = e.layer;

    resetHighlight(e.target, currentLayer, currentLayer.feature.geometry.sectionID);
    map.fitBounds(currentLayer.getBounds());
  });
};

/**
 * resetHighlight
 * @param shapesLayer
 * @param currentLayer
 * @param currentSectionID
 */
window.resetHighlight = function(shapesLayer, currentLayer, currentSectionID) {
  // reset all layers
  document.querySelectorAll('.section-highlight').forEach((element) => {
    element.classList.remove('show');
  });

  for (let key in shapesLayer._layers) {
    const tmpSectionColor = document.querySelector('div.section-item[data-section-id="' + shapesLayer._layers[key].feature.geometry.sectionID + '"]').getAttribute('data-color');
    if (tmpSectionColor) {
      shapesLayer._layers[key].setStyle({
        color: '#FFFFFF',
        weight: 1,
        opacity: .5,
        fillColor: tmpSectionColor,
        fillOpacity: .6,
      });
    }
  }

  // set highlight on current layer
  document.querySelector('div.section-item[data-section-id="' + currentSectionID + '"] > .section-highlight').classList.add('show');

  currentLayer.setStyle({
    fillOpacity: 0.9,
  });

  currentLayer.bringToFront();
};

/**
 * convertPoints
 * @param points
 * @param inv
 * @returns {*}
 * @copyright Lukas Kröss <lukas.kroess@beratungsring.org>
 */
window.convertPoints = function(points, inv) {
  inv = inv !== false;
  if (!convertPoints.converter) {
    var proj25832 = '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs';
    convertPoints.converter = proj4(proj25832);
  }

  return convertPoints.converter[inv ? 'inverse' : 'forward'](points);
};

/**
 * convertArray
 * @param object
 * @param inv
 * @copyright Lukas Kröss <lukas.kroess@beratungsring.org>
 */
window.convertArray = function(object, inv) {
  inv = inv !== false;
  for (const key in object) {
    if (Array.isArray(object) && Array.isArray(object[key])) {
      if (typeof (object[key][0]) == 'number') {
        object[key] = convertPoints(object[key], inv);
      } else {
        convertArray(object[key], inv);
      }
    }
  }
};